module.exports = __webpack_public_path__ + "static/media/about_2.69b58e4a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/about_2.jpg
// module id = 950
// module chunks = 0